const About = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", alignItems: "flex-start", gap: "20px" }}>
  <img
    src="IMG_7872.jpg"
    alt="profile pic"
    width="200px"
    style={{  borderRadius: "8px" }}
  />
  <div style={{ width: "300px" }}>
    <h1>About me</h1>
    <p>
      I am a Computer Science graduate from the University of Birmingham. I
      aspire to be a great developer and am interested in Full
      Stack Development, Data Science and Game Development. Outside of computer science I have a keen interest in music
      and play piano.
    </p>
  </div>
</div>

  )
}

export default About
